/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The type of the company

Values: 0=Master, 1=Subsidiary, 2=Asset, 3=Supplier, 4=Client, 5=Product, 6=Fund
 * @export
 * @enum {number}
 */

export enum CompanyType {
    Master = 0,
    Subsidiary = 1,
    Asset = 2,
    Supplier = 3,
    Client = 4,
    Product = 5,
    Fund = 6
}


